import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import MobileButtonsListItemComponents from './mobile-buttons-list-item.components';

interface OwnProps {
  isActive: boolean;
  header: string;
  content: string;
  toggleHandler: () => void;
  goForward: () => void;
  img: string;
  isGreyed: boolean;
}
const {
  Container,
  AccordionButton,
  ButtonIcon,
  ButtonText,
  Arrow,
  AccordionBody,
  AccordionContent,
  ContentText,
  ContentArrow
} = MobileButtonsListItemComponents;

const MobileButtonsListItemContent: React.FunctionComponent<OwnProps> = ({
  isActive,
  header,
  content,
  toggleHandler,
  img,
  goForward,
  isGreyed
}) => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <Container>
      <AccordionButton onClick={toggleHandler} isGreyed={isGreyed}>
        <ButtonIcon src={img} alt={t(header)} />
        <ButtonText isActive={isActive} tParams={header} />
        <Arrow isActive={isActive} />
      </AccordionButton>
      <AccordionBody
        isActive={isActive}
        contentHeight={contentRef.current?.offsetHeight || 0}>
        <AccordionContent ref={contentRef} onClick={goForward}>
          <ContentText tParams={content} />
          <ContentArrow />
        </AccordionContent>
      </AccordionBody>
    </Container>
  );
};

export default MobileButtonsListItemContent;
